import PropTypes from "prop-types";

const RectangleButton = ({
  element,
  onClick,
  disabled,
  hidden,
  className,
  sx,
}) => {
  return (
    <button
      className={`rectangle-button ${className}`}
      style={sx}
      onClick={onClick}
      disabled={disabled}
      hidden={hidden}
    >
      {element}
    </button>
  );
};

RectangleButton.defaultProps = {
  disabled: false,
  hidden: false,
  className: "secondary-color-scheme",
  sx: {},
  onClick: () => {},
};

RectangleButton.propTypes = {
  disabled: PropTypes.bool,
  hidden: PropTypes.bool,
  element: PropTypes.element.isRequired,
  onClick: PropTypes.func,
  className: PropTypes.string,
  sx: PropTypes.object,
};

export default RectangleButton;
